import services from './../../services/service'; // Service Class
import DashboardHeader from './../Dashboard-Header/index.vue'; // Dashboard Header
import DashboardSidebar from './../Dashboard-Sidebar/index.vue'; // Dashboard Sidebar
import DashboardFooter from './../Dashboard-Footer/index.vue'; // Dashboard Footer
//
import PaymentsAndUpdates from './../../mixins/payments_and_updates.js'; //  PaymentsAndUpdates == Resources
let service = new services();

export default {
    name: 'Contracts',
    mixins: [PaymentsAndUpdates],
    data () {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            cnpro_id: "",
            contracts: {},
            contract: {},
            contract_threads: {},
            panelFlag: false,
            addFlag: false,
            viewContractPanel: false,
            viewContractThread: false,
            viewQuote: false,
            contract_payment_ref: "",
            reviews: {},
            review: {},
            rate: "",
            canRate: true,
            img_url: service.imageURL,
            selected_contract: '',
            current_wallet_balance: 0,
            disable_btn: false
        }
    },
    components: {
        'component-header': DashboardHeader,
        'component-sidebar': DashboardSidebar,
        'component-footer': DashboardFooter
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal,cnpro){
                //this function will run whenever the input changes
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        //settings
        back(){
            this.panelFlag = false;
        },
        toggleMenuActions(){
            $('.toggle-menu-actions').toggle();
        },
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == 'view'){
                this.viewQuote = false;
                this.viewContractPanel = true;
                this.viewContractThread = false;
              }
            if(attr == 'viewContract'){
                this.viewQuote = false;
                this.viewContractPanel = true;
                this.viewContractThread = false;
                this.getContract(attr2);
            }
            if(attr == 'view-thread'){
                this.viewQuote = false;
                this.viewContractThread = true;
                this.viewContractPanel = false;
            }
            
        },
        setViewQuote(cnpro) {
            this.viewQuote= true;
            this.viewContractPanel = false;
            this.viewContractThread = false;
            //this.cnpro_id = cnpro;
        },
        setContractThreadPanel(contract,thread) {
            this.panelFlag = true
            this.addFlag = false;
            this.viewContractPanel = true;
            this.contract.contract_id = contract;
            this.contract_threads = thread;
            
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //quotes and contracts
        
        //get all user contracts
        getUserContracts() {
           this.viewQuote = false;
           let user_id = localStorage.getItem("cityneeds_token_key");
           service.getUserContracts(this, user_id).then(data => {
               if(data.body.status == 200) {
                    this.contracts = data.body.data;
                    let result = data.body.data;
                    let count = 0;
                    result.forEach(function(element) {
                        ++count;
                        if(count == 1){
                            this.contract = element; 
                            this.cnpro_id = this.contract.contract_cnpro_id;
                        }
                    }, this);
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        

        getContract(contract) {
            //this.viewQuote = false;
            service.getContract(this, contract).then(data => {
                if(data.body.status == 200) {
                    this.contract = data.body.data;
                    this.cnpro_id = this.contract.contract_cnpro_id;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        replyContract(contract,user) {
            var credentials = {
                contract_contract: contract,
                contract_user: user,
                contract_category: 3, //user
                contract_reply: this.contract.message
            }
            
            let navi = this.$router;
            if(credentials.contract_reply != null || credentials.contract_user != null || credentials.contract_user != null) {
                service.replyQuote(this, contract, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Sent!", "Success!");
                        this.getContract(contract); //rebind
                    }else {
                        toastr.error('Sorry, could not send', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        preAcceptQuote(contract) {
            this.selected_contract = contract;
            //open modal
            $('#paywith').modal();
        },

        // acceptQuote(contract) {
        acceptQuote(pay_with_option) {
            let contract = this.selected_contract;
            this.disable_btn = true;
            var credentials = {
                contract_contractor: this.user.user_id
            }
            let navi = this.$router;
            if(credentials.contract_contractor != null) {
                service.acceptQuote(this, contract.contract_id, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Quote Accepted!", "Success!");
                        // location.reload(); //change later

                        //CALL PAYMENT GATEWAY
                        //this.processPayment(data.body.data);
                        if(pay_with_option == "gateway"){
                        //CALL PAYMENT GATEWAY
                        this.processPayment(data.body.data);
                        }else{
                            this.processPaymentWithWallet(data.body.data)
                        }
                        // this.disable_btn = false;
                    }else {
                        toastr.error('Sorry, could not accept Quote', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                       // console.log("err",err)
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },

        rejectQuote(contract) {
            var credentials = {
                contract_contractor: this.user.user_id
            }
            let navi = this.$router;
            if(credentials.contract_contractor != null) {
                service.rejectQuote(this, contract, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Quote Rejected!", "Success!");
                        location.reload(); //change later
                    }else {
                        toastr.error('Sorry, could not reject Quote', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        closeModal(){
            location.reload(); 
        },
        confirmQuote(contract) {
            var credentials = {
                contract_contractor: this.user.user_id
            }
            let navi = this.$router;
            if(credentials.contract_contractor != null) {
                service.confirmContract(this, contract, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Job Confirmed!", "Success!");
                        //location.reload(); //change later
                       //activate review pop up
                        $('#reviewModal').modal('show');
                    }else {
                        toastr.error('Sorry, could not confirm Quote', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        closeContract() {
           let navi = this.$router;
            service.closeContract(this, this.contract.contract_id, this.contract).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Contract Closed!", "Success!");
                        location.reload(); //change later
                    }else {
                        toastr.error('Sorry, could not confirm Quote', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
           
        },
        
        //--//quotes and contracts

        //payments
         //connect to a payment gateway
        processPayment(data) {
            let obj = this;
            var handler = PaystackPop.setup({
            // key: 'pk_test_5e386f2b137cecdea7db6839c293614a8a115742',
            key: 'pk_live_1e88da135e1bd1205b610cac36fc6d9a27a2fbd8',
            Name: data.contract_contractor,
            email: data.contract_contractor_email || "admin@cityneeds.ng",
            //email: "webworks@webnigeria.ng",
            amount: (data.contract_labour_cost * 100), //in kobo
            ref: data.contract_ref,
            metadata: {
                custom_fields: [
                    {
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.contract_contractor
                    },
                    {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.contract_request
                    }
                    
                ]
            },
            
            callback: function(response){
                //post transaction
                let txn_payload = {
                    "transaction_payment_ref": data.contract_ref,
                    "transaction_module": 4,//contracts
                    "transaction_module_id": obj.selected_contract.contract_id,
                    "transaction_type": 1, //Contract Labour Cost
                    "transaction_mode": 1, //Payment Gateway
                    "transaction_mode_transaction_ref":ref, //use here
                    "transaction_amount_paid": data.contract_labour_cost,
                    "payer_name": data.contract_contractor || "",
                    "payer_email": data.contract_contractor_email || "", 
                    "payer_phone": obj.user.user_phone || 0,
                    "payer_user": obj.user.user_id || 0,
                };
                obj.postCNpaymentDetails(txn_payload);
                ///.///post transaction
                obj.updatePayment(response.trxref); 
                
            },
            onClose: function(){
                alert('window closed');
            }
            }); 
            handler.openIframe();
        },

        processPaymentWithWallet(data){
            this.amount_paid = data.plan_amount;
            var payload ={
                pay: this.user.user_id, // 
                txn_amount: data.contract_labour_cost,
                service: 3,//Contracts
                service_ref: data.contract_ref
            }
            service.postWalletPayout(this, payload).then(response => {
                if(response.body.status == 201) {
                    var txref = response.body.data_txn_ref;
                    //post transaction
                    let txn_payload = {
                        "transaction_payment_ref": data.contract_ref,
                        "transaction_module": 4,//contracts
                        "transaction_module_id": this.selected_contract.contract_id,
                        "transaction_type": 1, //Contract Labour Cost
                        "transaction_mode": 2, //CNrewards-Wallet
                        "transaction_mode_transaction_ref":txref, //use here
                        "transaction_amount_paid": data.contract_labour_cost,
                        "payer_name": this.user.user_fullname || "",
                        "payer_email": this.user.user_email || "", 
                        "payer_phone": this.user.user_phone || 0,
                        "payer_user": this.user.user_id || 0,
                    };
                    this.postCNpaymentDetails(txn_payload);
                    ///.///post transaction

                    //continue
                    this.updatePayment(response.body.data)
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        // update payments
        updatePayment(payment_ref) {
           var credentials = {
                contract_contractor: this.user.user_id
            }
            if(payment_ref != "") {
                service.updatePayment(this, payment_ref, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");
                        location.reload(); //change later
                    }else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
               toastr.error('Something went wrong', 'Warning!');
            }
            
        },

        //make complaint
        makeComplaint(contract,user) {
            var credentials = {
                contract_contract: contract,
                contract_user: user,
                contract_complaint: this.contract.complaint
            }
            
            let navi = this.$router;
            if(credentials.contract_complaint != null || credentials.contract_user != null || credentials.contract_contract != null) {
                service.makeComplaint(this, contract, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Sent!", "Success!");
                       this.getContract(contract); //rebind
                       //this.setPanel('viewContract',contract);
                    }else {
                        toastr.error('Sorry, could not send', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        resolveComplaint(complaint,complaint_id) {
            this.complaint = complaint;
            let navi = this.$router;
            service.resolveComplaint(this, complaint_id, complaint).then(data => {
                if(data.body.status == 200) {
                    toastr.success("Resolved!", "Success!");
                    this.complaint.contract_complaint_status = 15;
                }else {
                    toastr.error('Sorry, could not send', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
          },
        //reviews

        submitReview(cnpro) {
            var credentials = {
                review_category: 1, //cnpro review
                review_review: this.review.review,
                review_cnpro: cnpro,
                review_business: 0,
                review_user: this.user.user_id,
                check_rate: this.rate

            }
            let navi = this.$router;
            if(credentials.review_user != null && credentials.review_review != undefined) {
                if(credentials.check_rate != '') {
                    service.submitReview(this, credentials).then(data => {
                        if(data.body.status == 201) {
                           toastr.success("Review Submitted!", "Awesome!");
                           this.canRate = false;
                           location.reload(); //change later
                        }else {
                            toastr.error('Sorry, could not submit Review', 'Warning!');
                        }
                    }).catch((err) => {
                        if(err) {
                            toastr.error('Sorry, could not process information', 'Warning!');
                        }
                    })
                 }else {
                    toastr.error('Kindly Rate cnpro', 'Warning!');
                }
            }else {
                toastr.error('Kindly enter review', 'Warning!');
            }
        },
        //--//reviews

        //rate
        rateCnpro() {
            var credentials = {
                rating_category: 1, //cnpro rate
                rating_rate: this.rate,
                rating_cnpro: this.cnpro_id,
                rating_business: 0,
                rating_user: this.user.user_id
            }
            let navi = this.$router;
            if(credentials.rating_user != null || credentials.rating_rate != null) {
                service.submitRating(this, credentials).then(data => {
                    if(data.body.status == 201) {
                        toastr.success("Rated!", "Success!");
                        this.canRate = false;
                    }else {
                        toastr.error('Sorry, could not Rate', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        },
        //--//rate


    //wallet calls
    getWalletBalance() {
        let user_id = localStorage.getItem("cityneeds_token_key");
        service.getWalletBalance(this,user_id).then(data => {
             if(data.body.status == 200) {
                 this.current_wallet_balance = data.body.data_current_wallet_balance;
             }
         }).catch((err) => {
             if(err) {
                 toastr.error('Sorry, could not process information', 'Warning!');
             }
         })
    },

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        return currency.replace("NGN", ""); //strip off NGN
    },

    //....wallet calls

            
    },
    created: function(){
        this.preset();
        this.getUserContracts();
        this.getWalletBalance();
    }
}


// WEBPACK FOOTER //
// ./src/components/Contracts/script.js